import { AmortisationInput, AmortisationResult, Segment } from './amortisation.model';

/**
 * Was der Rechner an das Backend übergibt.
 *
 * Der Punkt: Nicht nur die E-Mail-Adresse, sondern die komplette Rechnung.
 * Damit weißt du vor dem ersten Anruf, mit wem du redest – Umsatzerwartung,
 * Direktvermarkter oder Händler, Break-even, Kauf- oder Miet-Kandidat.
 * Ein Lead mit 4.800 € Umsatzerwartung ist ein anderes Gespräch als einer mit 600 €.
 */
export interface CalculatorLead {
  email: string;
  input: AmortisationInput;
  result: LeadResultSummary;
  segment: Segment;
  /**
   * Indiz, nicht Prognose: Wer schneller amortisiert als der Kipppunkt
   * (Kaufpreis / Monatsmiete ≈ 23 Monate), fährt mit Kauf besser.
   */
  likelyPrefers: 'kauf' | 'miete';
  /** Von welcher Seite kam der Lead. */
  source: string;
  /** Sprache des Nutzers – bestimmt Sprache von E-Mail und PDF. */
  locale: string;
  createdAt: string;
}

/** Verdichtetes Ergebnis – gerundet, damit im CRM keine Nachkommastellen landen. */
export interface LeadResultSummary {
  grossProfit: number;
  monthlyCosts: number;
  monthlySurplus: number;
  breakevenMonths: number | null;
  withinAfa: boolean;
  transactionsPerMonth: number;
}

export function toLeadSummary(result: AmortisationResult): LeadResultSummary {
  return {
    grossProfit: Math.round(result.grossProfit),
    monthlyCosts: Math.round(result.operatingCost),
    monthlySurplus: Math.round(result.monthlySurplus),
    breakevenMonths: result.breakevenMonths !== null ? +result.breakevenMonths.toFixed(1) : null,
    withinAfa: result.withinAfa,
    transactionsPerMonth: Math.round(result.transactions),
  };
}
